import { useStaticQuery, graphql } from 'gatsby';

import type { ISiteDetails, TSiteLanguageAndDetails } from '@klaviyo-mkt/marketing-cms/src/staticTypes';

export const useSiteLanguagesQuery = () => {
  const data = useStaticQuery(graphql`
    query SiteLanguagesQuery {
      wp {
        sites {
          id
          includeInHfrelangTags
          path
          language {
            hreflang
            isoCode
            isoName
            locale
            name
            nativeName
          }
        }
      }
    }
  `);

  return {
    sites: (data?.wp?.sites?.map(({
      id, includeInHfrelangTags, path, language,
    }: ISiteDetails) => (includeInHfrelangTags ? {
      id,
      includeInHfrelangTags,
      path,
      ...language,
    } satisfies TSiteLanguageAndDetails : false)) || []).filter(Boolean),
  };
};
